import React from 'react';
import PropTypes from 'prop-types';
import styles from './PaymentInformationCheckDisplay.module.scss';

const PaymentInformationCheckDisplay = ({ source }) => {
	return (
		<div className={styles.container}>
			<div>{source.accountType === 1 ? 'Checking' : 'Savings'}</div>
			<div>Routing: {source.routingNumber}</div>
			<div>Account: {source.accountNumber}</div>
		</div>
	);
};

PaymentInformationCheckDisplay.propTypes = {
	source: PropTypes.object.isRequired
};

export default PaymentInformationCheckDisplay;
